import { Body1, Headline2, Headline3, Headline4, Subtitle1 } from 'stories/elements/Typography/Text'
import NewFeatureImageComponent from 'components/modules/LandingPage/NewFeatureComponent'
import { SliceType, SliceTypes } from 'interfaces/GeneratedLandingPage'
import CollabsibleAccordion from 'components/modules/Accordion/CollapsibleAccordion'
import theme from '../../stories/utils/theme'
import styled, { css } from 'styled-components'
import InformationGrid from 'components/modules/LandingPage/InformationGrid'
import AdvantageGrid from 'components/modules/LandingPage/AdvantageGrid'
import ContactPerson from 'components/modules/LandingPage/ContactPerson'
import Carousel from 'components/modules/Carousel/CarouselComponent'
import StatisticsGrid from 'components/modules/LandingPage/StatisticsGrid'
import TestimonialCarousel from 'components/modules/Carousel/TestimonialsCarousel'
import BenefitColumn from 'components/modules/LandingPage/BenefitColumn'
import ReviewsSection from 'components/modules/LandingPage/ReviewsSection'
import DarkReferences from 'components/modules/LandingPage/DarkReferences'
import InformationList from 'components/modules/LandingPage/InformationList'
import KnowunityNumbers from 'components/modules/LandingPage/KnowunityNumbers'
import FullPageFeatureGrid from 'components/modules/LandingPage/FullPageFeatureGrid'
import HeaderVideo from 'components/modules/LandingPage/HeaderVideo'
import SVGGrid from 'components/modules/LandingPage/SVGGrid'
import TextTestimonial from 'components/modules/Carousel/TextTestimonial'
import TextTestimonialCarousel from 'components/modules/Carousel/TextTestimonialCarousel'
import UserQuote from 'components/modules/LandingPage/UserQuote'
import { ComponentContainer } from 'components/layouts/Layouts.css'
import VerticalVideoCarousel from 'components/modules/Carousel/VerticalVideoCarousel'
import CompanyOffer from 'components/modules/LandingPage/CompanyOffer'
import FloatingBanner from 'components/modules/LandingPage/FloatingBanner'
import { trackEvent } from '../tracking/analytics-service'
import { AnalyticsEventLandingPageButtonClick } from '../constants/AnalyticsEventType'
import ExpansionBanner from 'components/modules/LandingPage/ExpansionBanner'
import { LandingPagePrismicDocument } from 'interfaces/PrismicDocument'
import SnapchatPixel from 'components/modules/SEO/SnapchatPixel'
import NextImage from 'components/elements/NextImage'
import SessionDurationTracking from 'components/modules/LandingPage/SessionDurationTracking'
import ExpansionAnimation from 'components/modules/LandingPage/ExpansionAnimation'
import { trackFacebookEvent } from '../tracking/facebook'
import { trackSnapchatEvent, SnapchatEvent } from '../tracking/snapchat'
import { trackTikTokEvent } from '../tracking/tiktok'
import BottomDownloadBanner from 'components/modules/LandingPage/BottomBanner'
import ArticlesShowcaseGrid from 'components/modules/LandingPage/ArticlesShowcaseGrid'
import FAQSchemaData from 'components/modules/SEO/FAQSchemaData'
import LinkedInMarketingTag from 'components/modules/LandingPage/LinkedInMarketingTag'
import FacebookMessengerWidget from 'components/modules/LandingPage/FacebookMessengerWidget'
import Stack from 'components/elements/Stack'

const Header = styled.div<{ backgroundColor?: string; fullWidth?: boolean }>`
    min-height: calc(80vh + var(--navbar-height));
    display: grid;
    align-items: center;

    background-color: ${({ backgroundColor }) => backgroundColor ?? theme.colors.white};
    background-size: cover;
    background-repeat: no-repeat;
    @media (max-width: 1050px) {
        height: auto;
        min-height: 450px;
        ${({ fullWidth }) =>
            fullWidth
                ? css`
                      background-image: none !important;
                  `
                : ''};
    }
`

const TextWrapper = styled.div<{ height: number }>`
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    gap: 20px;
    padding: 25px;
    height: ${({ height }) => (height ? `${height}px` : '100%')};
    * {
        max-width: 60%;
        @media (max-width: 1050px) {
            max-width: 80%;
        }
    }
    .mobile-image {
        display: none;
    }
    @media (max-width: 750px) {
        height: auto;
        .mobile-image {
            display: block;
        }
    }
`

export const returnSliceComponent = (data: SliceType) => {
    switch (data.slice_type) {
        case SliceTypes.Header:
            return (
                <Header
                    key={data.slice_type}
                    style={{
                        backgroundImage: data.primary.fullwidth
                            ? `url(${data.primary.image_webp?.url ?? ''}), url(${data.primary.image?.url ?? ''})`
                            : '',
                    }}
                    backgroundColor={data.primary.background_color}
                    fullWidth={data.primary.fullwidth}
                >
                    <NewFeatureImageComponent
                        title={data.primary.headline}
                        text={data.primary.text}
                        componentReferrerScreen="landing-page"
                        image={
                            <NextImage
                                src={data.primary.image?.url ?? ''}
                                alt={data.primary.image?.alt ?? 'feature header'}
                                width={data.primary.image.dimensions?.width}
                                height={data.primary.image.dimensions?.height}
                            />
                        }
                        mobileImageUrl={data.primary.mobile_image?.url ?? null}
                        buttonText={data.primary?.primary_button_text ?? ''}
                        secondButtonText={data.primary?.secondary_button_text ?? ''}
                        secondButtonTarget={data.primary.secondary_button_link}
                        target={data.primary.primary_button_link}
                        isHeader
                        isDarkTheme={data.primary.is_dark_theme}
                        alignBottom={data.primary.align_bottom}
                        transparentBackground={data.primary.fullwidth}
                        keepImageRatio
                        backgroundColor={data.primary.background_color}
                        primaryButtonColor={data.primary.primary_button_color}
                        advantages={data.items ? data.items.map((item) => item['advantage']).filter((x) => x) : []}
                        bottomSVG={data.primary.bottom_svg}
                        fullWidthImage={data.primary.fullwidth}
                        useLandingPageHeaderFont={data.primary.landingpage_header_font}
                        centerMobileImage={data.primary.center_mobile_image}
                        buttonStempel={data.primary.button_stempel}
                        showDownloadButtons={data.primary.show_download_buttons}
                        onButtonClick={() => {
                            if (data.primary.primary_button_click_analytics_event_value) {
                                trackEvent(AnalyticsEventLandingPageButtonClick, {
                                    value: data.primary.primary_button_click_analytics_event_value,
                                })
                            }
                            if (data.primary.primary_button_click_tiktok_event) {
                                trackTikTokEvent(data.primary.primary_button_click_tiktok_event)
                            }
                            trackSnapchatEvent(SnapchatEvent.CustomEvent1)
                            if (data.primary.primary_button_click_facebook_event) {
                                trackFacebookEvent(data.primary.primary_button_click_facebook_event)
                            }

                            if (data.primary.primary_button_click_facebook_event) {
                                trackFacebookEvent(data.primary.primary_button_click_facebook_event)
                            }
                        }}
                    />
                </Header>
            )
        case SliceTypes.HeaderVideo:
            return (
                <HeaderVideo
                    key={data.slice_type}
                    title={data.primary.title}
                    text={data.primary.text}
                    advantages={data.items ? data.items.map((item) => item['advantage']).filter((x) => x) : []}
                    primaryButtonText={data.primary.primary_button_text ?? ''}
                    primaryButtonTarget={data.primary.primary_button_link}
                    secondaryButtonText={data.primary.secondary_button_text ?? ''}
                    secondaryButtonTarget={data.primary.secondary_button_link}
                    videoSource={data.primary.video_source ?? ''}
                    eventTrackingValue={data.primary.primary_button_click_analytics_event_value ?? ''}
                    useLandingPageHeaderFont={data.primary.landingpage_header_font}
                    backgroundColor={data.primary.background_color}
                    textColor={data.primary.text_color}
                    primaryButtonColor={data.primary.primary_button_color}
                    videoFrame={data.primary.video_frame}
                    buttonStempel={data.primary.button_stempel}
                    onPrimaryButtonClick={() => {
                        if (data.primary.primary_button_click_tiktok_event) {
                            trackTikTokEvent(data.primary.primary_button_click_tiktok_event)
                        }
                        trackSnapchatEvent(SnapchatEvent.CustomEvent1)
                        if (data.primary.primary_button_click_facebook_event) {
                            trackFacebookEvent(data.primary.primary_button_click_facebook_event)
                        }
                    }}
                    isHeader={!data.primary.is_standard_component}
                />
            )
        case SliceTypes.TextTestimonial:
            return <TextTestimonial data={data.primary} />
        case SliceTypes.TextTestimonialCarousel:
            return (
                <TextTestimonialCarousel
                    data={data.items}
                    backgroundColor={data.primary.background_color}
                    backgroundImage={data.primary.background_image}
                />
            )
        case SliceTypes.FAQ:
            return (
                <ComponentContainer
                    key={data.slice_type}
                    color={data.primary.background_color ?? theme.colors.white}
                    id="faq"
                >
                    <section>
                        <FAQSchemaData faqItems={data.items} />
                        <Subtitle1 color={data.primary.title_color ?? theme.colors.knowunityBlue} textAlign="center">
                            {data.primary.title}
                        </Subtitle1>
                        <Headline2 color={theme.colors.accentBlue} textAlign="center" marginBottom={50}>
                            {data.primary.subtitle}
                        </Headline2>
                        {data?.items?.length > 0 &&
                            data.items.map((item, i) => (
                                <CollabsibleAccordion
                                    key={`faq-question-${i}`}
                                    text={<Body1 color={theme.colors.accentBlue}>{item.answer}</Body1>}
                                    title={item.question}
                                    accentBlue
                                />
                            ))}
                    </section>
                </ComponentContainer>
            )
        case SliceTypes.References:
            return (
                <DarkReferences
                    key={data.slice_type}
                    showWhiteLogos={data.primary.show_white_logos}
                    hideTitle={data.primary.hide_title}
                    backgroundColor={data.primary.background_color}
                />
            )
        case SliceTypes.FloatingBanner:
            return <FloatingBanner key={data.slice_type} data={data.primary} />
        case SliceTypes.Grid:
            return (
                <ComponentContainer key={data.slice_type} color={theme.colors.backgroundColorGray}>
                    <section>
                        <Subtitle1 color={theme.colors.knowunityBlue} textAlign="center">
                            {data.primary.title}
                        </Subtitle1>
                        <Headline2 color={theme.colors.headlineDark} textAlign="center" marginBottom={50}>
                            {data.primary.subtitle}
                        </Headline2>
                        <InformationGrid
                            items={data.items}
                            buttonText={data.primary.buttontext}
                            buttonLink={data.primary.button_link}
                        />
                    </section>
                </ComponentContainer>
            )
        case SliceTypes.SVGGrid:
            return (
                <ComponentContainer
                    key={data.slice_type}
                    color={data.primary.background_color ?? theme.colors.backgroundColorGray}
                >
                    {data.primary.title ? (
                        <section>
                            <Headline3 color={data.primary.title_color ?? theme.colors.knowunityBlue} textAlign="center">
                                {data.primary.title}
                            </Headline3>
                        </section>
                    ) : null}
                    <Headline4 color={theme.colors.deepSeaBlue} textAlign="center" marginBottom={50}>
                        {data.primary.subtitle}
                    </Headline4>
                    <SVGGrid items={data.items} />
                </ComponentContainer>
            )
        case SliceTypes.InformationList:
            return (
                <ComponentContainer
                    key={data.slice_type}
                    color={data.primary.background_color ?? theme.colors.backgroundColorGray}
                >
                    <section>
                        <Subtitle1 color={data.primary.title_color ?? theme.colors.knowunityBlue} textAlign="center">
                            {data.primary.title}
                        </Subtitle1>
                        <Headline2 color={theme.colors.headlineDark} textAlign="center" marginBottom={75}>
                            {data.primary.subtitle}
                        </Headline2>
                        <InformationList
                            items={data.items}
                            center={!!data.primary.center}
                            alignRow={data.primary.row_align}
                        />
                    </section>
                </ComponentContainer>
            )
        case SliceTypes.Advantages:
            return (
                <ComponentContainer
                    key={data.slice_type}
                    color={data.primary.background_color ?? theme.colors.lightCaption}
                    style={{ backgroundImage: `url(${data.primary.background_image?.url ?? ''})` }}
                >
                    <section>
                        <Subtitle1 color={data.primary.title_color ?? theme.colors.knowunityBlue} textAlign="center">
                            {data.primary.title}
                        </Subtitle1>
                        <Headline2 color={theme.colors.accentBlue} textAlign="center" marginBottom={50}>
                            {data.primary.subtitle}
                        </Headline2>
                        <AdvantageGrid
                            items={data.items}
                            buttonText={data.primary.buttontext}
                            buttonLink={data.primary.button_link}
                            buttonColor={data.primary.button_color}
                        />
                    </section>
                </ComponentContainer>
            )
        case SliceTypes.ContactPerson:
            return (
                <ContactPerson
                    key={data.slice_type}
                    isWhiteColor={data.primary.white_button}
                    backgroundColor={data.primary.background_color}
                    detail={{
                        subtitle: data.primary.subtitle,
                        headingText: data.primary.heading_text,
                        image: data.primary.image?.url ?? '',
                        name: data.primary.name,
                        email: data.primary.email,
                        buttonLink: `mailto:${data.primary.email}`,
                        buttonText: data.primary.button_text,
                        employeeTitle: data.primary.employee_title,
                        phoneNumber: data.primary.phone_number,
                    }}
                />
            )
        case SliceTypes.Carousel:
            return (
                <ComponentContainer key={data.slice_type} color={data.primary.background_color ?? theme.colors.accentBlue}>
                    <section>
                        <Subtitle1 color={data.primary.title_color ?? theme.colors.knowunityBlue} textAlign="center">
                            {data.primary.title}
                        </Subtitle1>
                        <Headline2 color={theme.colors.accentBlue} textAlign="center" marginBottom={0}>
                            {data.primary.subtitle}
                        </Headline2>
                    </section>
                    <Carousel
                        carouselData={data.items.map((item) => ({
                            text: item.text,
                            imageWebp: item.image_webp?.url ?? '',
                            footerInfo: {
                                title: item.footer_title,
                                subtitle: item.footer_subtitle,
                            },
                        }))}
                    />
                </ComponentContainer>
            )
        case SliceTypes.TestimonialCarousel:
            return (
                <ComponentContainer key={data.slice_type} color={data.primary.background_color ?? theme.colors.lightCaption}>
                    <section>
                        <Subtitle1 color={data.primary.title_color ?? theme.colors.knowunityBlue} textAlign="center">
                            {data.primary.title}
                        </Subtitle1>
                        <Headline2
                            color={data.primary.subtitle_color ?? theme.colors.accentBlue}
                            textAlign="center"
                            marginBottom={0}
                        >
                            {data.primary.subtitle}
                        </Headline2>
                        <TestimonialCarousel
                            buttonLink={data.primary.button_link}
                            buttonText={data.primary.button_text}
                            carouselData={data.items.map((item) => ({
                                text: item.text,
                                image: item.image?.url ?? '',
                                footerInfo: {
                                    title: item.user_title,
                                    subtitle: item.user_subtitle,
                                },
                            }))}
                        />
                    </section>
                </ComponentContainer>
            )
        case SliceTypes.VideoCarousel:
            return (
                <ComponentContainer key={data.slice_type} color={data.primary.background_color ?? theme.colors.lightCaption}>
                    <section>
                        <Subtitle1 color={data.primary.title_color ?? theme.colors.knowunityBlue} textAlign="center">
                            {data.primary.title}
                        </Subtitle1>
                        <Headline2
                            color={
                                data.primary.background_color === theme.colors.accentBlue
                                    ? theme.colors.white
                                    : theme.colors.accentBlue
                            }
                            textAlign="center"
                            marginBottom={0}
                        >
                            {data.primary.subtitle}
                        </Headline2>
                        <VerticalVideoCarousel
                            carouselData={data.items.map((item) => ({
                                videoLink: item.video_link ?? '',
                                image: item.image,
                                footerInfo: {
                                    title: item.user_title,
                                    subtitle: item.user_subtitle,
                                },
                            }))}
                        />
                    </section>
                </ComponentContainer>
            )
        case SliceTypes.BenefitColumn:
            return (
                <BenefitColumn
                    key={data.slice_type}
                    items={data.items}
                    buttonText={data.primary.button_text}
                    buttonLink={data.primary.button_link}
                    title={data.primary.title}
                    subtitle={data.primary.subtitle}
                    text={data.primary.text}
                    backgroundColor={
                        data.primary.background_color ? data.primary.background_color : theme.colors.backgroundColorGray
                    }
                    colorBottom={data.primary.bottom_color ? data.primary.bottom_color : theme.colors.backgroundColorGray}
                    colorTop={data.primary.top_color ? data.primary.top_color : theme.colors.backgroundColorGray}
                    buttonColor={data.primary.button_color}
                    subtitleColor={data.primary.subtitle_color}
                    textColor={data.primary.text_color}
                    titleColor={data.primary.title_color}
                    onClick={() => {
                        if (data.primary.button_click_tiktok_event) {
                            trackTikTokEvent(data.primary.button_click_tiktok_event)
                        }
                        trackSnapchatEvent(SnapchatEvent.CustomEvent1)
                        if (data.primary.button_click_facebook_event) {
                            trackFacebookEvent(data.primary.button_click_facebook_event)
                        }
                    }}
                />
            )
        case SliceTypes.ReviewsSection:
            return (
                <ComponentContainer key={data.slice_type} color={data.primary.background_color ?? theme.colors.white}>
                    <section>
                        <Subtitle1 color={data.primary.title_color ?? theme.colors.caption} textAlign="center">
                            {data.primary.title}
                        </Subtitle1>
                        <Headline2
                            color={data.primary.white_text ? theme.colors.white : theme.colors.accentBlue}
                            textAlign="center"
                            marginBottom={20}
                        >
                            {data.primary.subtitle}
                        </Headline2>
                        <Body1
                            color={data.primary.white_text ? theme.colors.white : 'rgba(43, 63, 95, 0.75)'}
                            textAlign="center"
                        >
                            {data.primary.text}
                        </Body1>
                    </section>
                    <ReviewsSection items={data.items} isWhiteColor={!!data.primary.white_text} />
                </ComponentContainer>
            )
        case SliceTypes.FeatureGrid:
            return (
                <ComponentContainer
                    key={`${data.slice_type}-${Math.random()}`}
                    color={data.primary.background_color ?? theme.colors.white}
                >
                    {data.primary.title || data.primary.subtitle ? (
                        <section>
                            <Subtitle1
                                color={data.primary.title_color ?? theme.colors.caption}
                                textAlign="center"
                                style={{ paddingTop: 25 }}
                            >
                                {data.primary.title}
                            </Subtitle1>
                            <Headline2 color={theme.colors.headlineDark} textAlign="center" marginBottom={20}>
                                {data.primary.subtitle}
                            </Headline2>
                        </section>
                    ) : null}
                    <FullPageFeatureGrid
                        data={data.items}
                        tabs={data.primary.tabs?.split(',') ?? undefined}
                        primaryTabColor={data.primary.background_color}
                        secondaryTabColor={data.primary.secondary_tab_background_color ?? theme.colors.white}
                    />
                </ComponentContainer>
            )
        case SliceTypes.SideFeartureGrid:
            return (
                <ComponentContainer
                    key={`side-feature-${data.slice_type}-${Math.random()}`}
                    color={data.primary.background_color ?? theme.colors.white}
                >
                    {data.primary.title || data.primary.subtitle ? (
                        <section>
                            <Subtitle1 color={data.primary.title_color ?? theme.colors.caption} textAlign="center">
                                {data.primary.title}
                            </Subtitle1>
                            <Headline2 color={theme.colors.headlineDark} textAlign="center" marginBottom={20}>
                                {data.primary.subtitle}
                            </Headline2>
                        </section>
                    ) : null}
                    <FullPageFeatureGrid data={data.items} showFeaturesSideBySide centerAll />
                </ComponentContainer>
            )
        case SliceTypes.StatisticsGrid:
            return <StatisticsGrid key={data.slice_type} data={data.primary} />
        case SliceTypes.ReviewsNumbersSlice:
            return <KnowunityNumbers key={data.slice_type} data={data.primary} />
        case SliceTypes.UserQuote:
            return <UserQuote key={data.slice_type} data={data.primary} />
        case SliceTypes.CompanyOffer:
            return <CompanyOffer key={data.slice_type} data={data.primary} items={data.items} />
        case SliceTypes.ExpansionBanner:
            return <ExpansionBanner key={data.slice_type} data={data.primary} />
        case SliceTypes.FullPageImage:
            return (
                <ComponentContainer
                    key={`${data.slice_type}-${Math.random()}`}
                    style={{
                        backgroundImage: `url(${data.primary.image_webp?.url ?? ''})`,
                    }}
                    color={data.primary.background_color ?? theme.colors.white}
                    hideMobileImage
                    alignImageToBottom
                >
                    <TextWrapper height={data.primary.image_webp.dimensions.height}>
                        <Headline2 color={theme.colors.white} textAlign="center" marginBottom={0}>
                            {data.primary.title}
                        </Headline2>
                        <div className="mobile-image">
                            {data.primary.mobile_image?.url ? (
                                <NextImage
                                    src={data.primary.mobile_image.url}
                                    width={data.primary.mobile_image?.dimensions.width}
                                    height={data.primary.mobile_image?.dimensions.height}
                                    alt={data.primary.mobile_image?.alt ?? 'mobile feature'}
                                />
                            ) : null}
                        </div>
                        <Body1 color={theme.colors.white} textAlign="center" marginBottom={20}>
                            {data.primary.text}
                        </Body1>
                    </TextWrapper>
                    <div className="hide-mobile">
                        {data?.items?.length ? <ReviewsSection items={data.items} isScrollable /> : null}
                    </div>
                </ComponentContainer>
            )
        case SliceTypes.ExpansionAnimation:
            return (
                <ComponentContainer
                    key={`${data.slice_type}-${Math.random()}`}
                    color={data.primary.background_color ?? theme.colors.white}
                >
                    <ExpansionAnimation items={data.items} primary={data.primary} />
                </ComponentContainer>
            )
        case SliceTypes.BottomDownloadBanner:
            return <BottomDownloadBanner text={data.primary.text} />
        case SliceTypes.PressArticlesShowcase:
            return (
                <ComponentContainer key={data.slice_type} color={theme.colors.snowWhite}>
                    <section>
                        <Stack gutter={10}>
                            <Subtitle1 color={theme.colors.deepSeaBlue} textAlign="center">
                                {data.primary.title}
                            </Subtitle1>
                            <Headline2 color={theme.colors.headlineDark} textAlign="center">
                                {data.primary.subtitle}
                            </Headline2>
                            <Body1 fontFamily="var(--font-inter)" fontWeight={400} textAlign="center">
                                {data.primary.text}
                            </Body1>
                        </Stack>
                    </section>
                    <ArticlesShowcaseGrid items={data.items} />
                </ComponentContainer>
            )
    }
}

export const snapchatMarketingPixels = (document: LandingPagePrismicDocument) => (
    <>{document.data.enable_snapchat_pixel ? <SnapchatPixel /> : null}</>
)

export const linkedInMarketingPixels = (document: LandingPagePrismicDocument) => (
    <>{document.data.enable_linkedin_pixel ? <LinkedInMarketingTag /> : null}</>
)

export const facebookMessengerWidget = (document: LandingPagePrismicDocument) => (
    <>{document.data.enable_facebook_messenger ? <FacebookMessengerWidget /> : null}</>
)

export const sessionDurationTrackingComponent = (document: LandingPagePrismicDocument) => (
    <>{document.data.enable_session_duration_tracking ? <SessionDurationTracking /> : null}</>
)
